import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomersGatewayService } from './customers-gateway.service';
import { CustomerFinanceSummary, CascadeSellInvoiceItem, CascadeSellInvoiceList, InvoiceRelatedOrders, DefaultList } from '../models/customers.model';
import { PriceList, PriceLists } from '../models/price-list.model';
import { Currency } from 'src/app/shared/models/currency.model';
import { Category } from 'src/app/shared/models/category.model';
import { Price } from '../models/price.model';
import { ExportPrice } from '../models/export-price.model';
import { WalletList, walletFilters, CascadeSellInvoiceFilters } from '../models/wallet-list.model';
import { Credit } from '../models/credit.model';
import { payLoad } from '../models/payload.model';
import { WalletStatistic } from '../models/wallet-statistic.model';
import { CustomerRegister, CustomerRegisterByCode } from '../models/customer-register.model';
import { DefaultPriceListItem } from '../models/default-price-list.model';
import { CustomersResults, Customers } from 'src/app/shared/models/customers.model';
import { AssignedProductListResults } from '../models/assigned-product-list.model';
import { AssignedProductListByPercent } from '../models/assigned-product-list-by-percent.model';
import { ProductSuggestions, DisplayPrice } from '../models/display-products.model';
import { ServerMessage } from 'src/app/shared/models/user.model';
import { MyMerchantList, Profile } from 'src/app/core/models/initials.model';
import { PaginationFilter } from '../../dashboard/models/pin-filter.model';
import { Login } from 'src/app/core/models/Login.model';

@Injectable({
  providedIn: 'root'
})

export class CustomersFacadeService {

  constructor(private customerGatewayService: CustomersGatewayService) { }

  getUserPriceList(userId: number): Observable<PriceLists> {
    return this.customerGatewayService.getUserPriceList(userId);
  }

  getUserPriceListByPercent(userId: number, filters?: any): Observable<AssignedProductListByPercent> {
    return this.customerGatewayService.getUserPriceListByPercent(userId, filters);
  }

  getUserAssignPercent(filters: any): Observable<any> {
    return this.customerGatewayService.getUserAssignPercent(filters);
  }

  getDefaultPriceListDetails(id: number) {
    return this.customerGatewayService.getDefaultPriceListDetails(id);
  }

  getCustomerAssignPercent(filters?: any): Observable<any> {
    return this.customerGatewayService.getCustomerAssignPercent(filters);
  }

  getDefaultPriceListByPercentDetails(id: number, filters) {
    return this.customerGatewayService.getDefaultPriceListByPercentDetails(id, filters);
  }

  getDefaultPriceListInfo(id: number): Observable<DefaultPriceListItem> {
    return this.customerGatewayService.getDefaultPriceListInfo(id);
  }

  getDefaultPriceListByPercentInfo(id: number): Observable<any> {
    return this.customerGatewayService.getDefaultPriceListByPercentInfo(id);
  }

  getdefaultPriceList(filters: Object) {
    return this.customerGatewayService.getDefaultPriceList(filters);
  }

  getdefaultPriceListByPercent(filters: Object) {
    return this.customerGatewayService.getDefaultPriceListByPercent(filters);
  }

  addDefaultPriceList(name: string): Observable<DefaultList> {
    return this.customerGatewayService.addDefaultPriceList(name);
  }

  addDefaultPriceListByPercent(name: string): Observable<any> {
    return this.customerGatewayService.addDefaultPriceListByPercent(name)
  }

  addDefaultPriceListInit(id: number, data: any[]): Observable<any> {
    return this.customerGatewayService.addDefaultPriceListInit(id, data);
  }

  addDefaultPercentListInitSingle(id: number, data): Observable<any> {
    return this.customerGatewayService.addDefaultPercentListInitSingle(id, data)
  }

  deleteDefaultPercentListInitSingle(listId: number, itemId: number): Observable<any> {
    return this.customerGatewayService.deleteDefaultPercentListInitSingle(listId, itemId)
  }

  addDefaultPriceListByPercentInit(id: number, data: any[]): Observable<any> {
    return this.customerGatewayService.addDefaultPriceListByPercentInit(id, data);
  }

  deleteDefaultPriceList(id: number): Observable<DefaultPriceListItem> {
    return this.customerGatewayService.deleteDefaultPriceList(id);
  }

  updateDefaultPriceListName(id: number, data): Observable<any> {
    return this.customerGatewayService.updateDefaultPriceListName(id, data);
  }

  updateDefaultPriceListByPercentName(id: number, data): Observable<any> {
    return this.customerGatewayService.updateDefaultPriceListByPercentName(id, data);
  }

  getDefaultPercentUserExceptions(id: number, filters?): Observable<any> {
    return this.customerGatewayService.getDefaultPercentUserExceptions(id, filters);
  }


  getAvailableCurrencies(): Observable<Currency[]> {
    return this.customerGatewayService.getAvailableCurrencies();
  }

  createDefaultPriceList(name: string): Observable<DefaultList> {
    return this.customerGatewayService.createDefaultPriceList(name);
  }

  getAvailableCategories(): Observable<Category[]> {
    return this.customerGatewayService.getAvailableCategories();
  }

  assignCustomerPrice(price: Price): Observable<Price> {
    return this.customerGatewayService.assignCustomerPrice(price);
  }

  assignCustomerPercent(price: Price): Observable<any> {
    return this.customerGatewayService.assignCustomerPercent(price);
  }

  assignDefaultPrice(userId: number, defaultId: number): Observable<ExportPrice> {
    return this.customerGatewayService.assignDefaultPrice(userId, defaultId);
  }

  assignDefaultLists(data): Observable<any> {
    return this.customerGatewayService.assignDefaultLists(data);
  }

  assignDefaultPercent(userId: number, defaultId: number): Observable<any> {
    return this.customerGatewayService.assignDefaultPercent(userId, defaultId);
  }

  removeCustomerPrice(id: number): Observable<Price> {
    return this.customerGatewayService.removeCustomerPrice(id);
  }

  removeCustomerPercent(id: number): Observable<Price> {
    return this.customerGatewayService.removeCustomerPercent(id);
  }

  getCustomerFinanceSummary(id?: number): Observable<CustomerFinanceSummary> {
    return this.customerGatewayService.getCustomerFinanceSummary(id);
  }

  getUserWallet(filters?: walletFilters): Observable<WalletList> {
    return this.customerGatewayService.getUserWallet(filters);
  }
  
  getUserWalletArchive(filters?: walletFilters): Observable<WalletList> {
    return this.customerGatewayService.getUserWalletArchive(filters);
  }

  getCascadeSellInvoiceItems(id: number, filters: CascadeSellInvoiceFilters): Observable<CascadeSellInvoiceItem[]> {
    return this.customerGatewayService.getCascadeSellInvoiceItems(id, filters);
  }

  getCascadeSellInvoiceList(filters: any): Observable<CascadeSellInvoiceList> {
    return this.customerGatewayService.getCascadeSellInvoiceList(filters);
  }

  getCascadeSellInvoiceDetails(id: number, filters: any) {
    return this.customerGatewayService.getCascadeSellInvoiceDetails(id, filters);
  }

  getCascadeInvoiceRelatedOrders(id: number, filters: any): Observable<InvoiceRelatedOrders> {
    return this.customerGatewayService.getCascadeInvoiceRelatedOrders(id, filters);
  }

  getCurrencies(): Observable<Currency[]> {
    return this.customerGatewayService.getCurrencies();
  }

  getShowingCurrencies(): Observable<Currency[]> {
    return this.customerGatewayService.getAvailableShowingCurrencies();
  }

  getCurrency(id: number): Observable<Currency> {
    return this.customerGatewayService.getCurrency(id);
  }

  addCredit(credit: Credit): Observable<Credit> {
    return this.customerGatewayService.addCredit(credit);
  }

  removeCredit(credit: Credit): Observable<Credit> {
    return this.customerGatewayService.removeCredit(credit);
  }

  createUserPayment(payLoad: payLoad): Observable<payLoad> {
    return this.customerGatewayService.createUserPayment(payLoad);
  }

  updateInvoiceItemPrice(data, type): Observable<any> {
    return this.customerGatewayService.updateInvoiceItemPrice(data, type);
  }

  getUserWalletStatistic(userId: number): Observable<WalletStatistic> {
    return this.customerGatewayService.getUserWalletStatistic(userId);
  }

  createCustomer(data: CustomerRegister): Observable<CustomerRegister> {
    return this.customerGatewayService.createCustomer(data);
  }

  createCustomerByCode(data: any): Observable<CustomerRegisterByCode> {
    return this.customerGatewayService.createCustomerByCode(data);
  }

  createCustomerKYC(data: any): Observable<any> {
    return this.customerGatewayService.createCustomerKYC(data);
  }

  addCustomerShowingPrice(data) {
    return this.customerGatewayService.addCustomerShowingPrice(data);
  }

  deleteCustomerShowingPrice(id) {
    return this.customerGatewayService.deleteCustomerShowingPrice(id)
  }

  getUserProfileById(id: number) {
    return this.customerGatewayService.getUserProfileById(id);
  }

  EnablePrintAccess(id: number, isAllow: boolean): Observable<any> {
    return this.customerGatewayService.enablePrintAccess(id, isAllow)
  }

  changeUserState(id: number, data) {
    return this.customerGatewayService.changeUserState(id, data);
  }

  importDefaultFile(id: number, data: any): Observable<any> {
    return this.customerGatewayService.importDefaultFile(id, data);
  }

  importDefaultFileByPercent(id: number, data: any): Observable<any> {
    return this.customerGatewayService.importDefaultFileByPercent(id, data);
  }

  getCustomerProductList(filters): Observable<any> {
    return this.customerGatewayService.getCustomerProductList(filters);
  }

  getCustomerProductListMembers(id: number): Observable<any> {
    return this.customerGatewayService.getCustomerProductListMembers(id);
  }

  deleteCustomerProductList(id: number): Observable<any> {
    return this.customerGatewayService.deleteCustomerProductList(id);
  }

  deleteCustomerProductListByPercent(id: number): Observable<any> {
    return this.customerGatewayService.deleteCustomerProductListByPercent(id);
  }

  getProductListActiveItems(id: number): Observable<any> {
    return this.customerGatewayService.getProductListActiveItems(id);
  }

  getProductListItems(limit: number = 25, offset: number = 0, query_params?): Observable<AssignedProductListResults> {
    return this.customerGatewayService.getProductListItems(limit, offset, query_params);
  }

  getProductListInfo(id): Observable<any> {
    return this.customerGatewayService.getProductListInfo(id);
  }

  createCustomerProductList(title): Observable<any> {
    return this.customerGatewayService.createCustomerProductList(title);
  }

  bulkAddItemsProductList(id, data) {
    return this.customerGatewayService.bulkAddItemsProductList(id, data);
  }

  updateCustomerProductList(id, data) {
    return this.customerGatewayService.updateCustomerProductList(id, data);
  }

  getPaymentMethods(): Observable<any> {
    return this.customerGatewayService.getPaymentMethods();
  }

  getUserPaymentEmails(filters): Observable<any> {
    return this.customerGatewayService.getUserPaymentEmails(filters);
  }

  createUserPaymentEmail(emailObj: any): Observable<any> {
    return this.customerGatewayService.createUserPaymentEmail(emailObj);
  }

  removeUserPaymentEmail(id: number): Observable<any> {
    return this.customerGatewayService.removeUserPaymentEmail(id);
  }

  editUserPaymentEmail(id: number, emailObj): Observable<any> {
    return this.customerGatewayService.editUserPaymentEmail(id, emailObj);
  }

  getProductSuggestions(filters): Observable<ProductSuggestions> {
    return this.customerGatewayService.getProductSuggestions(filters);
  }

  addDisplayPrice(obj: DisplayPrice): Observable<any> {
    return this.customerGatewayService.addDisplayPrice(obj);
  }

  setShowingCurrency(currency): Observable<any> {
    return this.customerGatewayService.setShowingCurrency(currency);
  }

  importDisplayPriceFile(data: any): Observable<any> {
    return this.customerGatewayService.importDisplayPriceFile(data);

  }

  getSalesManagerList(filters): Observable<any> {
    return this.customerGatewayService.getSalesManagerList(filters);
  }

  createSalesManager(data): Observable<any> {
    return this.customerGatewayService.createSalesManager(data);
  }

  /* DEPRECATED */
  deleteSalesManager(id: number):Observable<any> {
    return this.customerGatewayService.deleteSalesManager(id);
  }

  activateSalesManager(id: number):Observable<any> {
    return this.customerGatewayService.activateSalesManager(id);
  }

  deactivateSalesManager(id: number):Observable<any> {
    return this.customerGatewayService.deactivateSalesManager(id);
  }

  getSalesManagerDetails(id: number): Observable<any> {
    return this.customerGatewayService.getSalesManagerDetails(id);
  }

  updateSalesManager(id: number, data): Observable<any> {
    return this.customerGatewayService.updateSalesManager(id, data);
  }

  assignSalesManagerToCustomer(id, data): Observable<any> {
    return this.customerGatewayService.assignSalesManagerToCustomer(id, data);
  }

  getAssignedCustomersSalesManager(id): Observable<any[]> {
    return this.customerGatewayService.getAssignedCustomersSalesManager(id);
  }

  getSalesManagerReports(filters?): Observable<any> {
    return this.customerGatewayService.getSalesManagerReports(filters);
  }
  
  getSalesManagerGeneralReports(filters?): Observable<any> {
    return this.customerGatewayService.getSalesManagerGeneralReports(filters);
  }
  getSalesManagerDetailReports(filters?): Observable<any> {
    return this.customerGatewayService.getSalesManagerDetailReports(filters);
  }

  getMyMerchants(filters: PaginationFilter): Observable<MyMerchantList> {
    return this.customerGatewayService.getMyMerchants(filters);
  }

  selectCurrentCompany(company_id: number): Observable<Login> {
    return this.customerGatewayService.selectCurrentCompany(company_id);
  }

  setAssignPercentException(data: any): Observable<any> {
    return this.customerGatewayService.setAssignPercentException(data);
  }

  getAssignPercentExcel(filters: any):Observable<any> {
    return this.customerGatewayService.downloadAssignMap(filters);
  }

  defaultPriceListExcelBulkUpdate(data: any): Observable<any> {
    return this.customerGatewayService.defaultPriceListExcelBulkUpdate(data);
  }

  updateProductInMultiplePriceList(data: any): Observable<any> {
    return this.customerGatewayService.updateProductInMultiplePriceList(data);
  }

  getDefaultPriceListItemExport(id: number) {
    return this.customerGatewayService.getDefaultPriceListItemExport(id);
  }

  exportPriceListItemExcelFile(id) {
    return this.customerGatewayService.exportPriceListItemExcelFile(id);
  }

  exportCustomerDefaultAssignItems(id) {
    return this.customerGatewayService.exportCustomerDefaultAssignItems(id);
  }

  exportDefaultAssignPriceItems(id) {
    return this.customerGatewayService.exportDefaultAssignPriceItems(id);
  }

  getDefaultAssignPriceListItems(id, filters: Object) {
    return this.customerGatewayService.getDefaultAssignPriceListItems(id,filters);
  }
}

